import { render } from "./SmallVideoframe.vue?vue&type=template&id=00218a43"
import script from "./SmallVideoframe.vue?vue&type=script&lang=js"
export * from "./SmallVideoframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__